import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AlertMessageService, LoadingService } from "@serpro/ngx-suite-rfb";
import { Lud } from "src/app/shared/model/lud.model";
import { Recurso } from "src/app/shared/model/recurso.model";
import { Sinonimo } from "src/app/shared/model/sinonimo.model";
import { Fragmento } from "src/app/shared/model/fragmento.model";
import { AtoRecurso } from "src/app/shared/model/ato-recurso.model";
import { FragmentoAtoSegmento } from "src/app/shared/model/fragmento-ato-segmento.model";
import { LudService } from "src/app/shared/services/lud.service";
import { RecursoService } from "src/app/shared/services/recurso.service";
import { BancoRecursos } from "src/app/shared/util/banco-recursos.util";

@Component({
    selector: 'app-painel4-cadastro',
    templateUrl: './painel4-cadastro.component.html',
    styleUrls: ['./painel4-cadastro.component.css', '../../../../../src/app/shared/css/contraste.css']
})
export class Painel4CadastroComponent implements OnInit {
    @Input() bancoRecursos: BancoRecursos;
    @Output() dispositivoSelecionado = new EventEmitter<Lud>();
    @Output() atualizarRecursoSelecionado = new EventEmitter<Recurso | null>();
    
    recurso: Recurso
    readonly = false;
    dispositivosAto: Fragmento[] | null;
    filtroDispositivo: string;
    filtroSegmento: string;
    
    constructor(
        private readonly loadingService: LoadingService,
        private readonly alertMessageService: AlertMessageService,
        private readonly recursoService: RecursoService,
        private readonly ludService: LudService
        ) {}
        
    ngOnInit(): void {
        this.alertMessageService.dismissAll();
        this.dispositivosAto = [];
        this.filtroDispositivo = '';
        this.filtroSegmento = '';
    }
    
    public abrirRecurso(idRecurso: number) {
        this.loadingService.show();
        this.recursoService.buscarRecurso(idRecurso).subscribe({
            next: (recurso: Recurso) => {
                this.recurso = recurso;               
                this.ordenarFragmentos();        
                this.loadingService.hide();
                if (recurso.idAto) {
                    this.pesquisarDispositivos(recurso.idAto);
                }
            },
            error: () => {
                this.loadingService.hide();
            } 
        });
    }
    
    private pesquisarDispositivos(idAto: number) {
        this.loadingService.show();
        this.alertMessageService.dismissAll();
        this.ludService.consultarFragmentos(idAto).subscribe({
            next: (fragmentoAtoSegmento: FragmentoAtoSegmento[]) => {
                this.dispositivosAto = fragmentoAtoSegmento.map(f => new Fragmento(f.idSegmento.toString(), f.conteudo, f.ordemSegmentoAto));
                this.ordenarFragmentos();
                this.loadingService.hide();
            },
            error: (e) => {
                this.alertMessageService.error(e.error.message);
                this.loadingService.hide();
            }
        });
    }

    public incluirNovoRecursoNormas(recurso: Recurso) {
        this.recurso = recurso;
        this.pesquisarDispositivos(recurso.idAto);
    }
    
    public incluirNovoRecursoInternet() {
        this.recurso = new Recurso();
        this.recurso.incluirFragmentoIntegra();
    }

    public selecionarDispositivo(dispositivo: Fragmento) {
        this.alertMessageService.dismissAll();
        const lud = Lud.criarLudDoDispositivo(dispositivo, this.recurso, this.bancoRecursos);
        if (!this.recurso.idRecurso && !this.recurso.idAto) {
            this.bancoRecursos.incluirRecursoInternet(this.recurso);
        }
        this.dispositivoSelecionado.emit(lud);
    }

    public incluirSinonimo() {
        const novo = new Sinonimo('');
        this.recurso.sinonimos.push(novo);
        setTimeout(() => {
            const sinonimos = document.getElementsByName('novo-sinonimo');
            sinonimos[sinonimos.length-1].focus();
        }, 10);
    }

    public excluirSinonimo(i: number) {
        this.recurso.sinonimos.splice(i, 1);
    }

    public filtrarDispositivo(r: Fragmento[], filtro: string): Fragmento[] {
        if (r && r.length > 0) {
            const filtroLowerCase = filtro.toLowerCase();
            return r.filter(f => f.dispositivo.toLowerCase().indexOf(filtroLowerCase) >= 0);
        }
        return [];
    }

    public incluirDispositivo(f: Fragmento) {
        if (!this.recurso.fragmentos.find(a => a.fragmento == f.fragmento)) {
            const novo = new Fragmento(f.fragmento, f.dispositivo, f.ordemExibicaoFragmento);
            this.recurso.fragmentos.push(novo);
            this.ordenarFragmentos();
        }
        setTimeout(() => {
            const fragmentos = document.getElementsByName('novo-dispositivo');
            if (fragmentos) {
                for (let i = 0; i < fragmentos.length; i++) {
                    if (fragmentos[i].id == f.fragmento + '') {
                        (fragmentos[i] as HTMLInputElement).focus();
                        (fragmentos[i] as HTMLInputElement).select();
                    }
                }
            }
        }, 200);
    }

    public excluirDispositivo(i: number) {
        if (i > 0) {
            this.recurso.fragmentos.splice(i, 1);
        }
    }

    public incluirDispositivoManualmente() {
        this.filtroDispositivo = '';
        const i = this.recurso.fragmentos.length;
        const pos = this.recurso.fragmentos[i-1].ordemExibicaoFragmento;
        const novo = new Fragmento('','',pos+1);
        this.recurso.fragmentos.push(novo);
        setTimeout(() => {
            const fragmentos = document.getElementsByName('novo-fragmento');
            fragmentos[fragmentos.length-1].focus();
        }, 10);
    }

    public keyupFiltroSegmento() {
        if (!this.dispositivosAto) {
            return;
        }
        const encontrados = this.dispositivosAto.filter((s) => s.dispositivo.indexOf(this.filtroSegmento) >= 0);
        if (encontrados.length == 0) {
            return;
        }
        const i = this.dispositivosAto.indexOf(encontrados[0]);
        const segmento = document.getElementsByName('tr-tabela-segmento')[i];
        const rowTopPosition = segmento.offsetTop;
        const tabela = document.getElementsByName('tabela-segmentos')[0];
        tabela.scrollTop = rowTopPosition;
    }
    
    private ordenarFragmentos() {
        if (this.dispositivosAto) {
            // O código abaixo implementa a ordenação dos fragmentos com comparação alfanumérica (exceto o fragmento de íntegra).
            this.bancoRecursos.ordenarFragmentosPorDispositivo(this.recurso);

            // O código abaixo implementa a ordenação dos fragmentos de acordo com a ordem de exibição do dispositivo no ato.
            // É possível que o cliente solicite a ordenação desse tipo para atos do Normas.
            //
            // this.recurso.fragmentos = this.recurso.fragmentos
            // .map(f => ({
            //     ...f,
            //     ordemExibicaoFragmento: this.dispositivosAto!.find(d => d.fragmento === f.fragmento)?.ordemExibicaoFragmento || 0
            // }))
            // .sort((a, b) => a.ordemExibicaoFragmento - b.ordemExibicaoFragmento);
        }
    }

    public salvarRecurso() {
        if (!this.recurso.idRecurso && !this.recurso.idAto && this.recurso.sinonimos.every(s => this.recurso.identificador !== s.sinonimo)) {
            this.recurso.sinonimos.unshift(new Sinonimo(this.recurso.identificador));
        }
        this.alertMessageService.dismissAll();
        const msg = this.validarRecursoParaSalvar();
        if (msg) {
            this.alertMessageService.error(msg);
            return;
        }
        this.ordenarFragmentos();
        if (this.recurso.idRecurso) {
            this.atualizar();
        } else {
            this.salvar();
        }
        if (this.recurso.idAto) {
            const ar = new AtoRecurso();
            ar.idAto = this.recurso.idAto;
            ar.recurso = this.recurso;
            ar.epigrafe = this.recurso.identificador;
            this.bancoRecursos.incluirAtoRecursoNormas(ar);
        } else {
            this.bancoRecursos.incluirRecursoInternet(this.recurso);
        }
    }

    private salvar() {
        this.alertMessageService.dismissAll();
        this.loadingService.show();
        this.recursoService.salvarRecurso(this.recurso).subscribe({
            next: (recurso: Recurso) => {
                this.recurso = recurso;               
                this.loadingService.hide();
                this.alertMessageService.info('Recurso salvo no banco de LUDs.');
                this.atualizarRecursoSelecionado.emit(this.recurso);
            },
            error: (e) => {
                this.loadingService.hide();
                this.alertMessageService.error(e.error.message);
            } 
        });
    }

    private atualizar() {
        if (this.recurso.idRecurso) {
            this.alertMessageService.dismissAll();
            this.loadingService.show();
            this.recursoService.atualizarRecurso(this.recurso.idRecurso, this.recurso).subscribe({
                next: (recurso: Recurso) => {
                    this.recurso = recurso;
                    this.loadingService.hide();
                    this.alertMessageService.info('Recurso atualizado no banco de LUDs.');
                    this.atualizarRecursoSelecionado.emit(this.recurso);
                },
                error: (e) => {
                    this.loadingService.hide();
                    this.alertMessageService.error(e.error.message);
                } 
            });
        }
    }
    
    public excluirRecurso() {
        this.alertMessageService.dismissAll();
        if (this.recurso.idRecurso) {
            this.loadingService.show();
            this.recursoService.deletarRecurso(this.recurso.idRecurso).subscribe({
                next: () => {            
                    this.loadingService.hide();
                    this.alertMessageService.info('Item excluído do banco de LUDs.');
                    this.atualizarRecursoSelecionado.emit(null);
                },
                error: (e) => {
                    this.loadingService.hide();
                    this.alertMessageService.error(e.error.message);
                } 
            });
        }
    }

    private validarRecursoParaSalvar(): string | null {
        if (this.recurso.identificador.trim().length == 0) {
            return 'É necessário informar o nome do LUD.';
        }
        if (!this.recurso.idAto) {
            if (this.recurso.url.trim().length == 0) {
                return 'É necessário informar o URL de um LUD de internet.';
            }
            if (!this.validarURL(this.recurso.url)) {
                return 'O URL informado é inválido.';
            }
        }
        const sinonimos = this.recurso.sinonimos .map((s) => (s.sinonimo.trim()));
        if (sinonimos.length == 0) {
            return 'É necessário informar ao menos um sinônimo.';
        }
        if (sinonimos.filter(a => a.length == 0).length > 0) {
            return 'Não é permitido deixar campo de sinônimo vazio.';
        }
        if (sinonimos.filter(a => a.length < 5).length > 0) {
            return 'O sinônimo deve ser informado com pelo menos 5 caracteres.';
        }
        if (sinonimos.filter(a => a.length > 200).length > 0) {
            return 'O sinônimo deve ser informado com até 200 caracteres.';
        }
        const sinonimosRepetidos = this.localizarRepetidos(sinonimos);
        if (sinonimosRepetidos.length > 0) {
            return 'Não é permitida a repetição de sinônimos ("' + sinonimosRepetidos[0] + '").';
        }
        const fragmentos = this.recurso.fragmentos.map((f) => (f.fragmento.trim()));
        if (fragmentos.filter(a => a.length == 0).length > 1) {
            return 'Não é permitido deixar campo de fragmento vazio, exceto o correspondente à íntegra.';
        }
        if (fragmentos.filter(a => a.length > 30).length > 0) {
            return 'O fragmento deve ser informado com até 30 caracteres.';
        }
        const fragmentosRepetidos = this.localizarRepetidos(fragmentos);
        if (fragmentosRepetidos.length > 0) {
            return 'Não é permitida a vinculação de mais de um fragmento ao mesmo dispositivo ("#' + fragmentosRepetidos[0] + '").';
        }
        const dispositivos = this.recurso.fragmentos.map((f) => f.dispositivo.trim());
        if (dispositivos.filter(a => a.length == 0).length > 0) {
            return 'Não é permitido deixar campo de dispositivo vazio.';
        }
        if (dispositivos.filter(a => a.length > 30).length > 0) {
            return 'O dispositivo deve ser informado com até 30 caracteres.';
        }
        const dispositivosRepetidos = this.localizarRepetidos(dispositivos);
        if (dispositivosRepetidos.length > 0) {
            return 'Não é permitida a vinculação de mais de um fragmento ao mesmo identificador de dispositivo ("' + dispositivosRepetidos[0] + '").';
        }
        if (this.recurso.idAto && this.dispositivosAto != null) {
            const fragmentoInexistente = fragmentos.filter(f => !this.dispositivosAto?.some(d => f == '' || d.fragmento == f));
            if (fragmentoInexistente.length > 0) {
                return 'Não foi encontrado segmento no ato com fragmento #' + fragmentoInexistente[0] + '.';
            }
        }
        return null;
    }

    private validarURL(url: string): boolean {
        const urlRegex = /^(https?:\/\/)?([\w-]+\.)+[a-z]{2,20}(\/[\w\-.~:?#[\]@!§%$&'()*+,;=]*)*\/?$/i;
        const correto = urlRegex.test(url);
        if (!correto) {
            return false;
        }
        try {
            new URL(url);
            return true;
        } catch (e) {
            return false;
        }
    }

    private localizarRepetidos(array: string[]): string[] {
        // realiza contagem para cada valor diferente no array
        const contadores = array.reduce((contador, valor) => {
            contador[valor] = (contador[valor] || 0) + 1;
            return contador;
        }, {} as Record<string, number>);
        // filtra os valores que têm repetição
        return Object.entries(contadores)
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .filter(([_, contador]) => contador > 1)
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            .map(([valor, _]) => valor);
    }
}
